<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">Edit Service Item</h3>
        </v-flex>
        <v-flex xs12 md6 sm6 class="px-1">
          <v-card>
            <v-card-text>
              <form @submit.prevent="saveItem(item)">
                <v-text-field label="Title" v-model="item.title" required="required" :counter="50" maxLength="50" :error-messages="errors.title"></v-text-field>
                <v-file-input counter show-size truncate-length="15" v-model="item.file" label="Image" accept="image/*" :rules="rules" ref="image" :error-messages="errors.file"></v-file-input>
                <v-textarea auto-grow :rows="1" label="Text" v-model="item.text" :counter="200" maxLength="200" :error-messages="errors.text"></v-textarea>
                <v-text-field label="Order of Appearance" readonly type="number" min="1" v-model="service_item.order" :error-messages="errors.order"></v-text-field>
                <v-btn small type="submit" class="pull-right" color="primary" :loading="item.processing">Save</v-btn>
                <br>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
        <div>
          <v-card>
            <v-card-text>
              <v-img alt="uploaded image" :src="uploadedImage" lazy-src="/images/placeholder.gif" v-if="true" :width="height + 'px'" :height="height + 'px'"></v-img>
              <p v-text="item.title" :style="{ maxWidth: height + 'px' }" class="my-0 text-center"></p>
            </v-card-text>
          </v-card>
        </div>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'UpdateServiceItem',
    layout,
    props: [
      'errors',
      'service_item',
    ],
    components: {},
    metaInfo () {
      return {
        title: 'Edit Service Item | ' + this.service_item.title,
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        item: this.$inertia.form({
          title: this.service_item.title,
          text: this.service_item.text,
          file: null,
          id: this.service_item.id,
          '_method': 'PUT'
        }),
        rules: [
          value => !value || value.size < 512000 || 'Image size should be less than 512 kB!',
        ],
        uploadedImage: '/' + this.service_item.image,
        height: 200,
        saving: false,
      }
    },
    methods: {
      saveItem (service_item) {
        this.item.post('/serviceItems/' + service_item.id, service_item)
      },
    },
    watch: {
      'item.file': function (val) {
        // console.log(val);
        if (!val) {
          this.uploadedImage = ''
          return
        }
        var fileReader = new FileReader()
        fileReader.readAsDataURL(val)
        fileReader.onload = (value) => {
          this.uploadedImage = value.target.result
        }
      },
    }
  }
</script>

<style>
  h3 {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>
